import React from 'react';
import PendoIntegration from '../components/PendoIntegration';
import {
  UserPendoMetricsService,
  GuestPendoMetricsService,
  IUserMetricsService
} from '../services/user-metrics';
import { PendoAttributes } from '../components/PendoTracker';
import { useCookies } from 'react-cookie';
import accountService from 'src/services/account.service';

export const withPendo = (Comp) => (props) => {
  const [cookies] = useCookies(['userInfo']);
  const [metricsService, setService] = React.useState<
    IUserMetricsService<PendoAttributes>
  >();

  React.useEffect(() => {
    if (cookies.userInfo) {
      setService(new UserPendoMetricsService(props.cookies, accountService));
    } else {
      setService(new GuestPendoMetricsService());
    }
  }, [cookies]);

  return (
    <>
      {metricsService && <PendoIntegration metricsService={metricsService} />}
      <Comp {...props} />
    </>
  );
};

export default withPendo;
